<template>
  <kst-page-print-details page-footer
    v-slot="{ title }"
    @init="handleInit"
  >
    <div class="columns is-mobile">
      <div class="column is-half">
        <Company showImage :data="companyData" :customData="details"/>
      </div>
      <div class="column is-half">
        <div class="is-size-3">{{ title }}</div>
      </div>
    </div>

    <div class="columns is-mobile">
      <div class="column">
        <Details :details="details"/>
      </div>
      <div class="column">
        <Client :details="details"/>
      </div>
    </div>

    <Items class="block" :details="details" :items="details.Items"/>
    <Total class="block" :details="details" :companySettingData="companySettingData" />
  </kst-page-print-details>
</template>

<script>
import Model from "../InvModel.js";
import Services from "../../../services/Api/InvoiceServices.js";

import Client from "./InvPD_Client.vue";
import Details from "./InvPD_Details.vue";
import Items from "./InvPD_Items.vue";
import Total from "./InvPD_Total.vue";
import Company from "../../Company/RelatedPrintDetails/CpRPD.vue";

export default {
  components: {
    Client,
    Details,
    Items,
    Total,
    Company
  },
  data: () => ({
    companyData: {},
    companySettingData: {},
    details: {}
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadPrint) {
      this.resetData();

      const config = Services.getPrintDetailsData(id);
      loadPrint(config, this.handleInit_success);
    },
    handleInit_success(data) {
      this.companyData = data.CompanyDetails;
      this.companySettingData = data.CompanySettingDetails;
      this.details = data.Details;
      Model.setDetailsBySpecialPrice(this.details, data.SpecialPriceCount);

      for (const item of this.details.Items) {
        Model.updateItem(item);
      }
    },

    /*** custom ***/

    resetData() {
      this.companyData = {};
      this.companySettingData = {};
      this.details = {};
    }
  }
}
</script>